const timeZoneOptions = [
  {
    code: 'HKT',
    value: 'Asia/Hong_Kong',
  },
  {
    code: 'GMT',
    value: 'Europe/London',
  },
  {
    code: 'IST',
    value: 'Asia/Kolkata',
  },
  {
    code: 'EET',
    value: 'Asia/Nicosia',
  },
]

const currencies = [
  {
    title: 'Vietnamese Dong',
    value: 'VND',
    id: 'a73244aa-b72c-e911-a8a0-002248005556',
  },
  {
    title: 'Chinese Yuan',
    value: 'CNY',
    id: '35d4d0f6-b72c-e911-a8a0-002248005556',
  },
  {
    title: 'Thai Baht',
    value: 'THB',
    id: '9d42b31e-b82c-e911-a8a0-002248005556',
  },
  {
    title: 'Indonesian Rupiah',
    value: 'IDR',
    id: 'a7785251-b82c-e911-a8a0-002248005556',
  },
  {
    title: 'Malaysian Ringgit',
    value: 'MYR',
    id: '17698acf-b82c-e911-a8a0-002248005556',
  },
]

const globalMessages = {
  errorMessage: 'Something went wrong!',
  errorDescription: 'We are currently working on it. Please try again...!',
}

const urls = {
  setUp2faUrl: '/user/setup-twoFactor-authentictaion',
  codeValidatorUrl: '/user/twoFactor-validation',
  personalDetailsUrl: '/user/personal-details',
}

const clients = [
  {
    id: '111',
    clientName: 'MayFly Entertainment',
    clientType: 'MERCHANT',
  },
  {
    id: '112',
    clientName: 'TGP',
    clientType: 'MERCHANT',
  },
  {
    id: '113',
    clientName: 'PayConstruct',
    clientType: 'MERCHANT',
  },
  {
    id: '114',
    clientName: 'Cross Bar FX',
    clientType: 'INTRODUCER',
  },
]

const introducerClients = [
  {
    id: '111',
    clientName: 'MayFly Entertainment',
  },
  {
    id: '112',
    clientName: 'TGP',
  },
  {
    id: '113',
    clientName: 'PayConstruct',
  },
]

const vendors = [
  {
    id: '111',
    vendorName: 'Tobby',
    vendorType: 'SWAP',
  },
  {
    id: '112',
    vendorName: 'KLMC',
    vendorType: 'SWAP',
  },
  {
    id: '113',
    vendorName: 'FIDELIS',
    vendorType: 'FX',
  },
  {
    id: '114',
    vendorName: 'SGM',
    vendorType: 'FX',
  },
]

export default {
  timeZoneOptions,
  globalMessages,
  urls,
  clients,
  introducerClients,
  currencies,
  vendors,
}
